import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import GlobalStyle from './global-style';
import UserData from './user-data';
import TemplateBuilder from './templates';
import NotFound from './not-found';
import { applyFilters } from '@wordpress/hooks';

const Content = (props) => {

    const { activeMenu, menus } = props;
    const menuTitle = getTitleBySlug(menus, activeMenu);

    let content = '';
    switch (activeMenu) {
        case 'global-style':
            content = <GlobalStyle {...props} />;
            break;
        case 'user-data':
            content = <UserData {...props} />
            break;
        case 'jkit-404':
            content = <NotFound {...props} />
            break;
        case 'jkit-header':
        case 'jkit-footer':
            content = <TemplateBuilder {...props} menuTitle={menuTitle} />;
            break;
        default:
            content = applyFilters(
                'jkit.dashboard.theme.builder',
                '',
                {
                    ...props,
                    menuTitle: menuTitle
                }
            );
            break;
    }



    return <div className="f-theme-content-wrapper">

        <div className="f-theme-content-header">
            <h3>{menuTitle}</h3>

        </div>
        <div className='f-theme-content'>
            {content}
        </div>
    </div >;
};

const getTitleBySlug = (menus, slug) => {
    for (const menu of menus) {
        const submenu = menu.submenu;
        if (submenu) {
            const item = submenu.find(item => item.slug === slug);
            if (item) {
                return item.title;
            }
        }
    }
    return null;
};



export default Content;